import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { formatTRY } from "../lib/mw";

const AYLAR = ["OCA", "ŞUB", "MAR", "NİS", "MAY", "HAZ", "TEM", "AĞU", "EYL", "EKİ", "KAS", "ARA"];
const COLS = [["ciro", "CİRO"], ["tahsilat", "TAHSİLAT"], ["giden_ciro", "GİDEN"], ["gelen_ciro", "GELEN"], ["kargo", "KARGO"]];

const Pct = ({ cur, prev }) => {
  if (!prev && !cur) return <span className="text-slate-600">—</span>;
  if (!prev) return <span className="text-emerald-400">YENİ</span>;
  const p = ((cur - prev) / prev) * 100;
  const up = p >= 0;
  return <span className={up ? "text-emerald-400" : "text-rose-400"}>{up ? "▲" : "▼"}{Math.abs(p).toLocaleString("tr-TR", { maximumFractionDigits: 1 })}%</span>;
};

export const MonthCompare = ({ months, bid }) => {
  const [open, setOpen] = useState(true);
  const nowM = new Date().toISOString().slice(0, 7);
  const list = (months || []).filter((m) => m.ay <= nowM);
  if (!list.length) return null;
  return (
    <div data-testid={`month-compare-${bid}`} className="mt-2 rounded-md border border-slate-800 bg-slate-950/40">
      <button data-testid={`month-compare-toggle-${bid}`} onClick={() => setOpen((o) => !o)} className="flex w-full items-center gap-1 px-2 py-1 text-[10px] font-bold text-slate-400 hover:text-slate-200">
        {open ? <ChevronDown className="h-3.5 w-3.5" /> : <ChevronRight className="h-3.5 w-3.5" />} AY AY KARŞILAŞTIRMA (ÖNCEKİ AYA GÖRE)
      </button>
      {open && (
        <div className="max-h-[230px] overflow-auto">
          <table className="w-full text-[10px]">
            <thead className="sticky top-0 bg-slate-950 text-slate-500"><tr><th className="px-1 text-left">AY</th>{COLS.map(([k, l]) => <th key={k} className="px-1 text-right">{l}</th>)}</tr></thead>
            <tbody>
              {[...list].reverse().map((m) => {
                const i = list.indexOf(m); const prev = list[i - 1];
                return (
                  <tr key={m.ay} data-testid={`mc-row-${bid}-${m.ay}`} className={`border-t border-slate-800 ${m.ay === nowM ? "bg-blue-500/10" : ""}`}>
                    <td className="px-1 py-0.5 font-bold text-slate-300">{AYLAR[Number(m.ay.slice(5)) - 1]}</td>
                    {COLS.map(([k]) => (
                      <td key={k} className="px-1 py-0.5 text-right font-mono">
                        <div className="text-slate-200">{k === "kargo" ? m[k] : formatTRY(m[k])}</div>
                        <div>{prev ? <Pct cur={m[k]} prev={prev[k]} /> : <span className="text-slate-600">—</span>}</div>
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
